import { render, staticRenderFns } from "./blank-layout.vue?vue&type=template&id=356d3406&scoped=true"
import script from "./blank-layout.vue?vue&type=script&lang=js"
export * from "./blank-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356d3406",
  null
  
)

export default component.exports